<template>
  <div class="collect">
    <top-bar></top-bar>
    <collect-cont></collect-cont>
  </div>
</template>
<script>
  import TopBar from './collectTopBar'
  import CollectCont from './collectCont'

  export default {
    name: "collect",
    components: {TopBar, CollectCont},
  }
</script>
<style lang="stylus" scoped>
  @import '../../../assets/css/func.styl'
  .collect
    width: 100%
    background: #f8f8f8
    footer
      display: flex
      height: .3rem
      padding-bottom: .8rem
      flex-direction: row
      justify-content: center
      align-items: center
      text-align center
      font-size: .24rem
</style>


// WEBPACK FOOTER //
// src/components/share/collect/collect.vue